import { useCallback, useEffect } from 'react';

import { createBasePayload, triggerEvent } from '../utils/tracking';
import { EventParam, EventType } from '../utils/types';

export type UsePageLoadProps = {
  touchpointType: string;
  productCardOrder: string;
};

export type UsePageLoadReturn = {
  handleClickCallback: (eventParam: EventParam) => void;
};

export const usePageLoad = ({
  touchpointType,
  productCardOrder,
}: UsePageLoadProps): UsePageLoadReturn => {
  useEffect(() => {
    triggerEvent(
      EventType.PAGEVIEW,
      EventParam.VIEW,
      createBasePayload(touchpointType, productCardOrder),
    );
  }, [productCardOrder, touchpointType]);

  const handleClickCallback = useCallback(
    (eventParam: EventParam) => {
      triggerEvent(
        EventType.EVENT,
        eventParam,
        createBasePayload(touchpointType, productCardOrder),
      );
    },
    [touchpointType, productCardOrder],
  );

  return { handleClickCallback };
};
